import router from "../router";
import store from "../store";
import i18n from "../i18n";

export const createPayment = ({ amount, email, ticketId, entity, entityID, descr, operatorId, publicId, returning_uri, access_token_url_safe }) => {
    const onSuccess = async () => {
        if (!window.localStorage.getItem("@private/token")) {
            return router.push(`/notifications/payment/success?type=${entity}&entity_id=${entityID}`);
        }

        if (entity !== "order") {
            await store.dispatch("ticket/checkTicket", { ticketId });
            router.push(`/payment/success?type=${entity}&orderNumber=${ticketId}&entity_id=${entityID}&token=${access_token_url_safe}`);
        } else {
            // location.replace(`/payment/success?type=${entity}&entity_id=${entityID}`);
            router.push(`/payment/success?type=${entity}&orderNumber=${ticketId}&entity_id=${entityID}`);
        }
    };

    const onFailure = () =>
        router.push(
            "/notifications/payment/failed?reference=" +
                router.currentRoute.fullPath.split("?operator=")[0] +
                (entity === "order" ? "&returning_uri=" + returning_uri : ""),
        );

    const w = new window.cp.CloudPayments({ language: i18n.locale || i18n.fallbackLocale, googlePaySupport: true, applePaySupport: true });

    const options = {
        // publicId: entity === "order" ? publicId : "pk_e3bd1877ed1b8532e3cc6d714c802", // id из личного кабинета
        publicId: publicId, // id из личного кабинета
        description: descr, // назначение
        amount,
        currency: "RUB",
        invoiceId: ticketId,
        accountId: email,
        data: {
            type: entity,
            operatorID: operatorId,
        }
    };

    console.log(options);

    w.charge(options, onSuccess, onFailure);
};
